import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContainerInspectionViewComponent } from './container-inspection-view/container-inspection-view.component';
import { ListComponent } from './list/list.component';


const routes: Routes = [
  { path: '', component: ListComponent },
  { path: 'view', component: ContainerInspectionViewComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContainerRoutingModule { }
